export default "__VITE_ASSET__Ci94dNIM__"